import CFAdminModal from "../../components/CFAdminModal";
import CFAdminDataTable from "../../components/CFAdminDataTable";
import CFAdminNotification from "../../components/CFAdminNotification";
import React, {useEffect, useRef, useState} from "react";
import {ActionMode} from "../../constants/ActionMode";
import ActionButtons from "../../util/renderActionButtons";
import ExcludedErrorVinService from "../../services/ExcludedErrorVinService";
import CFAdminExcludedErrorVinForm from "./CFAdminExcludedErrorVinForm";

const ExcludedErrorVinActionsCell = (props: any) => {
    const { onEdit, onDelete } = props.column;
    const inUse = props.row.original.usedFlag;
    return (
        <ActionButtons
            props={props}
            handleChange={onEdit}
            handleDelete={onDelete}
            disabled={inUse}
        />
    );
};

function CFAdminExcludedErrorVin() {

    const childCompRef = useRef<any>();
    const [data, setData] = useState([]);
    const [isDelete, setIsDelete] = useState(false);
    const [initialValues, setInitialValues] = useState({
        id: 0,
        mode: ActionMode.Add,
        excludedErrorVin: "",
        note: "",
        userKey:"",
        modified:"",
        usedFlag: false,
    });
    const [actionText, setActionText] = useState("Add Excluded Error Vin");

    const retrieveOperations = async () => {
        ExcludedErrorVinService.getAllExcludedError()
            .then(response => {
                setData(response.data.excludedErrorVinResponses);
            })
            .catch(e => {
                console.log(e);
            });
    };

    useEffect(() => {
        retrieveOperations();
    }, []);

    const confirmSuccessMessage = async (value: any) => {
        childCompRef.current.successMessage(value);
    };
    const confirmErrorMessage = async (value: any) => {
        childCompRef.current.failureMessage(value);
    };

    const [isOpen, setIsOpen] = useState(false);

    const handleEdit = (event: any) => {
        setActionText("Edit Excluded Error VIN");
        setInitialValues({
            ...initialValues,
            id: event.originalRow.id,
            mode: ActionMode.Edit,
            excludedErrorVin: event.originalRow.excludedErrorVin,
            note: event.originalRow.note,
            userKey: event.originalRow.userKey,
            modified: event.originalRow.modified,
            usedFlag: event.originalRow.usedFlag,
        });
        setIsOpen(!isOpen);
        setIsDelete(false);
    }

    const handleDelete = (event: any) => {
        setActionText("Delete Excluded Error Vin");
        setInitialValues({
            ...initialValues,
            id: event.originalRow.id,
            mode: ActionMode.Delete,
            excludedErrorVin: event.originalRow.excludedErrorVin,
            note: event.originalRow.note,
            userKey: event.originalRow.userKey,
            modified: event.originalRow.modified,
            usedFlag: true,
        });
        setIsDelete(true);
        setIsOpen(!isOpen);
    }

    const columns = [
        {
            Header: "Excluded Id",
            accessor: 'id'
        },
        {
            Header: "Excluded Error VIN",
            accessor: 'excludedErrorVin'
        },
        {
            Header: "Notes",
            accessor: 'note'
        },
        {
            Header: "Last Modified By",
            accessor: 'userKey'
        },
        {
            Header: "Last Modified Date",
            accessor: 'modified'
        },
        {
            Header: "Actions",
            onEdit: handleEdit,
            onDelete: handleDelete,
            Cell: ExcludedErrorVinActionsCell
        }
    ];

    const toggleModal = (isAdd?:boolean) => {
        setInitialValues({
            ...initialValues,
            id: 0,
            excludedErrorVin: '',
            note: '',
            userKey: "",
            modified: "",
            usedFlag: false,
            mode: isAdd ? ActionMode.Add : ActionMode.Edit
        });
        isAdd && setActionText("Add Excluded Error Vin");
        setIsOpen(!isOpen);
        setIsDelete(false);
    }

    return (

        <div className="make-component">
            <h2 className="fomo-type--title">Manage Excluded Error VIN</h2>
            <CFAdminModal
                isOpen={isOpen}
                toggle={toggleModal}
                isAdd={true}
                title={actionText}
            >
                <CFAdminExcludedErrorVinForm {...initialValues}
                                             isDelete={isDelete}
                                             toggleModal={toggleModal}
                                             refreshData={retrieveOperations}
                                             successMessage={confirmSuccessMessage}
                                             errorMessage={confirmErrorMessage}/>
            </CFAdminModal>

            <CFAdminDataTable
                columns={columns}
                data={data}
                toggleModal={toggleModal}
                textModal={'Add Excluded Error Vin'}
            />

            <CFAdminNotification ref={childCompRef}/>
        </div>
    );
}

export default CFAdminExcludedErrorVin;